import React from "react";

const ADO_Field = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Field</h1>
      <p>This is the ADO Field page content.</p>
    </div>
  );
};

export default ADO_Field;
